import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Users/rjuncosa/Code/edgewise/webcomponents/node_modules/css-loader/dist/runtime/api.js'
import '/Users/rjuncosa/Code/edgewise/webcomponents/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Users/rjuncosa/Code/edgewise/webcomponents/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('ewc-project-contact-form', wrap(Vue, () => import('~root/src/webcomponents/ProjectContactForm.vue?shadow')))

window.customElements.define('ewc-project-documents', wrap(Vue, () => import('~root/src/webcomponents/ProjectDocuments.vue?shadow')))

window.customElements.define('ewc-project-floor-plans-grid', wrap(Vue, () => import('~root/src/webcomponents/ProjectFloorPlansGrid.vue?shadow')))

window.customElements.define('ewc-project-image-gallery', wrap(Vue, () => import('~root/src/webcomponents/ProjectImageGallery.vue?shadow')))

window.customElements.define('ewc-project-inventory-grid', wrap(Vue, () => import('~root/src/webcomponents/ProjectInventoryGrid.vue?shadow')))

window.customElements.define('ewc-project-inventory-list', wrap(Vue, () => import('~root/src/webcomponents/ProjectInventoryList.vue?shadow')))

window.customElements.define('ewc-project-lots-list', wrap(Vue, () => import('~root/src/webcomponents/ProjectLotsList.vue?shadow')))

window.customElements.define('ewc-project-open-house-flash', wrap(Vue, () => import('~root/src/webcomponents/ProjectOpenHouseFlash.vue?shadow')))

window.customElements.define('ewc-unit-buy-now-button', wrap(Vue, () => import('~root/src/webcomponents/UnitBuyNowButton.vue?shadow')))